/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';
import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { DropTarget } from 'react-dnd'

import { TableContainer, Table, TableHead, TableBody, TableRow, TableCell, TableFooter, TableSortLabel, TablePagination, Typography, Card, CardActionArea, CardContent } from '@material-ui/core'
import { FixedSizeList } from 'react-window';

import RecordSummary from './RecordSummary';
import RecordIcon from './RecordIcon';

const fieldDropSpec = {
    drop(props, monitor, component) {
        console.log("IRC :: Drop Details : ", {
            props : props,
            monitor : monitor,
            component : component
        })
        return {
            group_data : props.group_data,
            location : props.location
        }
    },
    canDrop (props, monitor) {
        return props.accept_field_drops
    }
}

function collect (connect, monitor) {
    return {
        connectDropTarget : connect.dropTarget(),
        isOver: monitor.isOver(),
        isOverCurrent: monitor.isOver({ shallow: true }),
        item : monitor.getItem(),
        canDrop : monitor.canDrop()
    }
}

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc014e",
      },
    },
});

const styles = theme => ({
    headerStyle : {
        color : '#707070',
        backgroundColor : '#F5F5F5',
        fontSize : 11,
        border : 'none'
    }
})

class RecordList extends Component {
    state = {
        rows_per_page : 10,
        page : 0,
        record_in_focus : null
    }

    componentDidUpdate (prevProps) {
        if (this.props.fields !== prevProps.fields) {
            this.setState({...this.state, page : 0})
        }
    }

    sortFilterHandler = (key) => {
        let group_filter = this.props.group_filter
        if (group_filter.sort_by === key) {
            group_filter.direction = group_filter.direction === 'asc' ? 'desc' : 'asc'
        } else {
            group_filter.sort_by = key
            group_filter.direction = 'asc'
        }
        this.props.update_filter(group_filter)
    }

    getFields = () => {
        let sort_field = this.props.group_filter.sort_by
        let sort_direction = this.props.group_filter.direction

        let sorted_fields = []

        switch (sort_field) {
            // case "Name":
            //     if (sort_direction === 'asc') {
            //         let fields = this.props.fields.sort((a,b) => {
            //             if(a.field < b.field) { return -1; }
            //             if(a.field > b.field) { return 1; }
            //             return 0
            //         })
            //         sorted_fields = fields
            //     } else if (sort_direction === 'desc') {
            //         let fields = this.props.fields.sort((a,b) => {
            //             if(a.field < b.field) { return 1; }
            //             if(a.field > b.field) { return -1; }
            //             return 0
            //         })
            //         sorted_fields = fields
            //     }
            //     break
            
            case "Score":
                if (sort_direction === 'asc') {
                    let fields = this.props.fields.sort((a,b) => {
                        if(a.score < b.score) { return -1; }
                        if(a.score > b.score) { return 1; }
                        return 0
                    })
                    sorted_fields = fields
                } else if (sort_direction === 'desc') {
                    let fields = this.props.fields.sort((a,b) => {
                        if(a.score < b.score) { return 1; }
                        if(a.score > b.score) { return -1; }
                        return 0
                    })
                    sorted_fields = fields
                }
                break

            default :
                if (sort_direction === 'asc') {
                    let fields = this.props.fields.sort((a,b) => {
                        if(a.wv_field_list[sort_field] < b.wv_field_list[sort_field]) { return -1; }
                        if(a.wv_field_list[sort_field] > b.wv_field_list[sort_field]) { return 1; }
                        return 0
                    })
                    sorted_fields = fields
                } else if (sort_direction === 'desc') {
                    let fields = this.props.fields.sort((a,b) => {
                        if(a.wv_field_list[sort_field] < b.wv_field_list[sort_field]) { return 1; }
                        if(a.wv_field_list[sort_field] > b.wv_field_list[sort_field]) { return -1; }
                        return 0
                    })
                    sorted_fields = fields
                }
                break
        }

        let fields = sorted_fields
        if (this.props.pagination) {
            fields = this.state.rows_per_page > 0 ? fields.slice(this.state.page * this.state.rows_per_page, this.state.page * this.state.rows_per_page + this.state.rows_per_page) : fields
        }

        return fields
    }

    renderHeaderCells = (cell) => {
        const { classes } = this.props
        switch (cell) {
            case "$icon" :
                return (
                    <TableCell 
                        className = {classes.headerStyle}
                        padding = 'none' 
                        size = 'small'
                        align = 'center'
                    ></TableCell>
                )

            case "$golden" :
                return (
                    <TableCell 
                        className = {classes.headerStyle}
                        padding = 'none' 
                        size = 'small'
                        align = 'center'
                    ></TableCell>
                )

            case "$primary" :
                return (
                    <TableCell 
                        className = {classes.headerStyle}
                        padding = 'none' 
                        size = 'small'
                        align = 'center'
                    ></TableCell>
                )

            // case "Name" :
            //     return (
            //         <TableCell 
            //             className = {classes.headerStyle}
            //             padding = 'none' 
            //             size = 'small'
            //             align = 'left'
            //         >
            //             <TableSortLabel
            //                 active = {this.props.group_filter.sort_by === 'Name'}
            //                 direction = {this.props.group_filter.sort_by === 'Name' ? this.props.group_filter.direction : 'asc'}
            //                 onClick = {() => this.sortFilterHandler('Name')}
            //             >
            //                 Name
            //             </TableSortLabel>
            //         </TableCell>
            //     )
            
            case "Score": 
                return (
                    <TableCell 
                        className = {classes.headerStyle}
                        padding = 'none' 
                        size = 'small'
                        align = 'center'
                    >
                        <TableSortLabel
                            active = {this.props.group_filter.sort_by === 'Score'}
                            direction = {this.props.group_filter.sort_by === 'Score' ? this.props.group_filter.direction : 'asc'}
                            onClick = {() => this.sortFilterHandler('Score')}
                        >
                            Score
                        </TableSortLabel>
                    </TableCell>
                )

            case "$options":
                return (
                    <TableCell 
                        className = {classes.headerStyle}
                        padding = 'none' 
                        size = 'small'
                        align = 'center'
                    ></TableCell>
                )

            default :
                return (
                    <TableCell 
                        className = {classes.headerStyle}
                        padding = 'none' 
                        size = 'small'
                        align = 'left'
                    >
                        <TableSortLabel
                            active = {this.props.group_filter.sort_by === cell}
                            direction = {this.props.group_filter.sort_by === cell ? this.props.group_filter.direction : 'asc'}
                            onClick = {() => this.sortFilterHandler(cell)}
                        >
                            {cell}
                        </TableSortLabel>
                    </TableCell>
                )
        }
    }

    renderHead = () => {
        const { classes } = this.props
        return (
            <TableRow style = {{width : '90%', backgroundColor : '#F5F5F5'}}>
                {this.props.columns.map(column => {
                    return this.renderHeaderCells(column)
                })}
            </TableRow>
        )
    }

    renderBody = () => {
        // return this.renderVirtualRows(this.props.fields)
        // let fields = [...this.props.fields]
        // if (this.props.pagination) {
        //     fields = this.state.rows_per_page > 0 ? fields.slice(this.state.page * this.state.rows_per_page, this.state.page * this.state.rows_per_page + this.state.rows_per_page) : fields
        // }
        console.log(this.props.fields)
        return (
            <TableBody>
                {this.renderRows(this.getFields())}
            </TableBody>
        )
    }

    getFieldsForSummary = () => {
        let fields_for_summary = [...this.props.report_info.operation_config.global_key_fields.value, ...this.props.report_info.operation_config.global_match_fields.value]
        console.log('IRC :: Fields For Summary : ', fields_for_summary)
        return fields_for_summary
    }

    renderRows = (fields) => {
        console.log("renderRows fields:",fields)
        let rows = fields.map(field => {
            return (
                <RecordSummary
                    key = {field.record_id}
                    field_data = {field}
                    group_display_name = {this.props.group_display_name}
                    field_display_name = {this.props.field_display_name}
                    location = {this.props.location}
                    body_height = {this.props.body_height}
                    field_in_focus = {this.props.field_in_focus}
                    focus_field = {(field_object, field_type, chained_func) => this.props.focus_field(field_object, field_type, chained_func)}
                    field_type = {this.props.field_type}
                    handleDropped = {(field_data, field_type, drop_result) => {
                        if (drop_result) {
                            this.props.move_field(field_data, field_type, drop_result)
                        }
                    }}
                    columns = {this.props.columns}
                    syncing_field = {this.props.syncing_field}
                    unfocus_field = {() => this.props.unfocus_field()}
                    unsynced_fields = {this.props.unsynced_fields}
                    remove_field = {(field) => this.props.remove_field(field)}
                    create_new_group_from_field = {(field_data) => this.props.create_new_group_from_field(field_data)}
                    make_singleton = {(field_data) => this.props.make_singleton(field_data)}
                    show_group_name = {this.props.show_group_name}
                    highlight_name = {this.props.highlight_name}
                    focus_record = {(record) => this.props.focus_record(record)}
                    record_in_focus = {this.props.record_in_focus}
                    fields_for_summary = {this.getFieldsForSummary()}
                    set_record_primary = {(field_data) => this.props.set_record_primary(field_data)}
                />
            )
        })

        return rows
    }

    // getFields=()=> {
    //     let fields = [...this.props.report_info.operation_config.global_key_fields.value, ...this.props.report_info.operation_config.global_match_fields.value]
    //     return fields
    // }

    renderVirtualRows = (fields) => {
        var toPX = require('to-px')
        return (
            <FixedSizeList height = {this.props.body_height - 10} width = {toPX("25vw") - 20} itemSize = {30} itemCount = {fields.length}>
                {({index , style}) => (
                    <RecordSummary
                        style = {style}
                        key = {fields[index].record.record_id}
                        field_data = {fields[index]}
                        location = {this.props.location}
                        body_height = {this.props.body_height}
                        field_in_focus = {this.props.field_in_focus}
                        focus_field = {(field_object, field_type, chained_func) => this.props.focus_field(field_object, field_type, chained_func)}
                        field_type = {this.props.field_type}
                        handleDropped = {(field_data, field_type, drop_result) => {
                            if (drop_result) {
                                this.props.move_field(field_data, field_type, drop_result)
                            }
                        }}
                        columns = {this.props.columns}
                        syncing_field = {this.props.syncing_field}
                        unfocus_field = {() => this.props.unfocus_field()}
                        unsynced_fields = {this.props.unsynced_fields}
                        remove_field = {(field) => this.props.remove_field(field)}
                        create_new_group_from_field = {(field_data) => this.props.create_new_group_from_field(field_data)}
                        make_singleton = {(field_data) => this.props.make_singleton(field_data)}
                        show_group_name = {this.props.show_group_name}
                        highlight_name = {this.props.highlight_name}
                        focus_record = {(record) => this.props.focus_record(record)}
                        record_in_focus = {this.props.record_in_focus}
                        fields_for_summary = {[...this.props.report_info.operation_config.global_key_fields.value, ...this.props.report_info.operation_config.global_match_fields.value]}
                    />
                )}
            </FixedSizeList>
        )
    }  
    
    renderRecord = () => {
        console.log("record : ", this.state.record_in_focus)
        return(
            <Card>
                <CardContent>
                    <div style={{display: 'flex', flexDirection:'column'}}>
                        <div style={{padding:'5px'}}>
                            <RecordIcon/>
                        </div>
                        <div style={{padding:'5px'}}>
                            <Typography variant = 'subtitle2' color ='textPrimary'>ID</Typography>
                            <Typography variant = 'subtitle2' color ='textSecondary'>{this.state.record_in_focus.record_id}</Typography>
                        </div>
                        {
                            Object.keys(this.state.record_in_focus.wv_field_list).map((key)=>{
                                return (
                                    <div style={{padding:'5px'}}>
                                        <Typography variant = 'subtitle2' color ='textPrimary'>{key}</Typography>
                                        <Typography variant = 'subtitle2' color ='textSecondary'>{this.state.record_in_focus.wv_field_list[key]}</Typography>
                                    </div>
                                )
                            })
                        }
                        
                    </div>
                </CardContent>
            </Card>
        )

    }

    render() { 
        const { canDrop, isOver, connectDropTarget } = this.props
        const borderSpacing = '0px 7px'
        const color = canDrop && isOver ? '#e8fffd' : ''

        return connectDropTarget (
                <div style = {{
                    marginTop : this.props.top_margin,
                    padding : '10px'
                }}>
                    <TableContainer style = {{
                        height : (this.props.body_height) + "px",
                        backgroundColor : color
                    }}>
                        {this.props.pagination && <TablePagination
                            style = {{width : '100%', margin : 0, padding : 0}}
                            rowsPerPageOptions={[5, 10, 15, 20]}
                            colSpan={4}
                            count = {this.props.fields.length}
                            rowsPerPage={this.state.rows_per_page}
                            page = {this.state.page}
                            onPageChange={(event, newPage) => this.setState({...this.state, page : newPage})}
                            onRowsPerPageChange={(event) => this.setState({...this.state, rows_per_page: parseInt(event.target.value, 10)})}
                            SelectProps={{
                                inputProps: { 'aria-label': 'rows per page' },
                                native: true,
                            }}
                        />}
                        <Table
                            style = {{
                                borderCollapse : 'separate',
                                borderSpacing : borderSpacing,
                            }}
                            stickyHeader
                        >
                            <TableHead>
                                {this.renderHead()}
                            </TableHead>
                            {/* {this.state.record_in_focus? this.renderRecord():this.renderBody()} */}
                            {this.renderBody()}
                        </Table>
                    </TableContainer>
                </div>
        );
    }
}
 
export default withStyles(styles)(DropTarget('record', fieldDropSpec, collect)(RecordList));